<template>
  <div>
    <el-dialog title="赛事详情" :visible.sync="_dialogVisible" :show-close="false" :close-on-click-modal="false">
      <div class="center">
        <iframe :src="url" height="600px" />
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="confirm" type="primary">确定</el-button> -->
        <el-button @click="cancel">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "index",
  data() {
    return {
      url: "",
      value: "",
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
      ],
    };
  },
  props: {
    dialogVisible: {
      type: Boolean,
      required: true,
      default: false,
    },
    activityID: {
      type: String,
      required: true,
      default: "",
    },
  },
  watch: {
    activityID(val) {
      this.url =
        "https://wap.sctynews.cn/h5/index.html#/pages/apply/index?id=" + val;
    },
  },
  computed: {
    _dialogVisible: {
      get() {
        return this.dialogVisible;
      },
      set(val) {
        this.$emit("update:dialogVisible", val);
      },
    },
  },
  methods: {
    //确定
    confirm() {
      this._dialogVisible = false;
    },
    //取消
    cancel() {
      this.$emit("updateActivityID");
      this._dialogVisible = false;
    },
  },
  mounted() {},
};
</script>
<style  scoped lang="less">
.center {
  display: flex;
  justify-content: center;
}
.el-input-number .el-input {
  width: 100%;
}
</style>